import React from "react";
import "../styles/AcademicCalendar.css";
import { FaFilePdf } from "react-icons/fa";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// Import PDF
import Academic_Calendar from "../Assets/Pdfs/Academic_Calender_2026.pdf";

export default function AcademicCalendar() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div className="calendar-page">
            <section className="calendar-section pdf-section">
                <h2>
                    <FaFilePdf className="pdf-icon" /> Academic Calendar 2026
                </h2>

                {/* PDF Viewer */}
                <div className="pdf-viewer">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={Academic_Calendar}
                            plugins={[defaultLayoutPluginInstance]}
                        />
                    </Worker>
                </div>

                {/* Download link */}
                <p className="pdf-download">
                    <a
                        href={Academic_Calendar}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Download Academic Calendar 2026
                    </a>
                </p>
            </section>

            <footer className="calendar-footer">
                <p>Stay updated with the academic schedule for the year 2026.</p>
            </footer>
        </div>
    );
}
